import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDModal from "components/MDModal";
import React from "react";
import FormAddCountry from "./FormAddCountry";

export default function CountryModal({ open, setOpen, title, children }) {
  return (
    <MDModal title={title} open={open} setOpen={setOpen}>
      {children}
    </MDModal>
  );
}
